import { render, staticRenderFns } from "./applyProduct.vue?vue&type=template&id=0fa6a6db&scoped=true"
import script from "./applyProduct.vue?vue&type=script&lang=js"
export * from "./applyProduct.vue?vue&type=script&lang=js"
import style0 from "./applyProduct.vue?vue&type=style&index=0&id=0fa6a6db&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa6a6db",
  null
  
)

export default component.exports